import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';

function LoginButton() {
    const { loginWithRedirect, isLoading } = useAuth0();

    return (
        <Button color="inherit" variant="outlined" onClick={() => loginWithRedirect()}>
            {isLoading && <CircularProgress color={'inherit'} size={18} style={{ margin: '3px 8px 3px 0' }} />}
            <span>Log In</span>
        </Button>
    );
}

export default LoginButton;
